// @flow
import React from 'react';
import PropTypes from "prop-types";
import NotificationActions from '../actions/NotificationActions';
import NotificationStore from '../stores/NotificationStore';
import {CSSTransition, TransitionGroup} from "react-transition-group";

class Notifier extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			dismissedAlerts: []
		};
	}
	dismiss(item) {
		if (this.props.onDismiss) {
			//if callback specified, call it
			this.props.onDismiss(item);
		} else {
			//if no callback for dismissal, just update our state
			let newData = this.state.dismissedAlerts.slice();
			newData.push(item);
			this.setState({ dismissedAlerts: newData });
		}
	}
	render() {
		let alerts = [];
		let enterTimeout = 500;
		let exitTimeout = 300;

		for (let i = 0; i < this.props.alerts.length; i++) {
			if (this.state.dismissedAlerts.indexOf(this.props.alerts[i]) < 0) {
				let alert = this.props.alerts[i];
				alerts.push(alert);

				if (alert.timeout || this.props.timeout) setTimeout(this.dismiss.bind(this, alert), ((alert.timeout ? alert.timeout : this.props.timeout) + enterTimeout + exitTimeout));
			}
		}

		let i = -1;
		return (
			<div className="alert-notifier-container">
				<TransitionGroup>
					{alerts.map(function (item) {
						i++;
						item.key = i;
						if (["success", "info", "warning", "danger"].indexOf(item.type) < 0) {
							item.type = "info";
						}
						let css = "alert alert-dismissible alert-" + item.type;
						let headline = item.headline ? <strong>{item.headline}&nbsp;</strong> : null;
						return (
							<CSSTransition key={i} classNames="alert" timeout={{enter: enterTimeout, exit: exitTimeout}} >
								<div className={css} key={i}>
									<button type="button" className="close" title="Dismiss"
											onClick={this.dismiss.bind(this, item)}>&times;</button>
									{headline}{item.message}
								</div>
							</CSSTransition>
						);
					}.bind(this))}
				</TransitionGroup>
			</div>
		);
	}
}

Notifier.propTypes = {
	alerts: PropTypes.array.isRequired,
	onDismiss: PropTypes.func
};


class Notification extends React.Component {
	constructor(props) {
		super(props);
		this.state = NotificationStore.getState();
		this.onChange = this.onChange.bind(this);
		this.dismissAlert = this.dismissAlert.bind(this);
	}
	
	componentDidMount() {
		NotificationStore.listen(this.onChange);
	}
	
	componentWillUnmount() {
		NotificationStore.unlisten(this.onChange);
	}
	
	onChange(state) {
		this.setState(state);
	}
	
	dismissAlert(item) {
		NotificationActions.dismiss(item);
	}
	
	render() {
		return (<Notifier alerts={this.props.onlyLast && this.state.notifications != null ?
			this.state.notifications.slice(-1): this.state.notifications} onDismiss={this.dismissAlert} />);
	}
}

Notification.propTypes = {
	onlyLast: PropTypes.bool
};

Notification.defaultProps = {
	onlyLast: false
};

export default Notification;
